// src/components/common/BackButton.jsx
import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../../styles/App.css';

const BackArrow = () => (
  <svg 
    width="24" 
    height="24" 
    viewBox="0 0 24 24" 
    fill="none" 
    stroke="currentColor" 
    strokeWidth="2.5" 
    strokeLinecap="round" 
    strokeLinejoin="round"
  >
    <path d="M19 12H5" />
    <path d="M12 19l-7-7 7-7" />
  </svg>
);

const BackButton = () => {
  const navigate = useNavigate();
  const location = useLocation();

  if (location.pathname === '/') {
    return null;
  }

  const handleBack = () => {
    // ✅ CHECK: If opened in new tab, try to use window.opener
    if (window.opener && !window.opener.closed) {
      // Opened from another page - close this tab and return to opener
      window.close();
    } else if (window.history.length > 1) {
      // Normal navigation - go back
      navigate(-1);
    } else {
      // Direct link or no history - go to homepage
      window.location.href = '/';
    }
  };

  return (
    <button 
      className="floating-back-btn" 
      onClick={handleBack} 
      aria-label="Go back"
    >
      <BackArrow />
    </button>
  );
};

export default BackButton;
